import React, { useState, useEffect } from 'react';

export const InfoField = ({ label, value, loading }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isStringValue = typeof value === 'string';

  return (
    <div
      style={{
        marginBottom: '8px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row', // responsive
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: '6px'
      }}
    >
      <div
        style={{
          fontSize: '0.8rem',
          fontWeight: '500',
          color: '#6c757d'
        }}
      >
        {label}:
      </div>

      {loading ? (
        <div
          style={{
            width: '120px',
            height: '14px',
            backgroundColor: '#e0e0e0',
            borderRadius: '4px'
          }}
        />
      ) : isStringValue ? (
        <div
          style={{
            fontSize: '0.8rem',
            fontWeight: '400',
            color: '#495057',
            wordWrap: 'break-word',
            whiteSpace: 'normal'
          }}
        >
          {value}
        </div>
      ) : (
        value
      )}
    </div>
  );
};
